import './RelativeTimeWithIcon.scss'
import React from 'react'
import ClockIcon from '../../../legacy_components/Icons/Article/ClockIcon'
import PropTypes from 'prop-types'
import RelativeTime from '../RelativeTime'
import { getLocales } from '../../../utilities/locales'

const RelativeTimeWithIcon = ({ date, locale, itemProp, variant = 'default', color = 'default' }) =>
  <div className={ `widget-temporal-relative-time-with-icon color-${color}` }>
    <ClockIcon height={ 16 } />
    <RelativeTime date={ date } locale={ locale } itemProp={ itemProp } variant={ variant }/>
  </div>

RelativeTimeWithIcon.propTypes = {
  date: PropTypes.oneOfType([
    PropTypes.instanceOf(Date),
    PropTypes.string,
  ]).isRequired,
  locale: PropTypes.oneOf(getLocales()).isRequired,
  itemProp: PropTypes.string,
  variant: PropTypes.oneOf(['default', 'full']),
  color: PropTypes.oneOf(['default', 'light-mobile']),
}

export default RelativeTimeWithIcon
